import { Link } from 'react-router-dom';
import { assetPath } from '../../infrastructure/utils/asset.utils';
import { useState } from 'react';

interface HeaderProps {
  readonly subtitle?: string;
}

export function Header({ subtitle = 'Welcome — 1CL Hub' }: Readonly<HeaderProps>) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="header-inner container">
        <div className="brand">
          <Link to="/hub" className="brand-link" aria-label="Return to Hub">
            <img src={assetPath('1CLLogo.png')} alt="1CL" className="brand-logo" />
          </Link>
          <div className="brand-text">
            <p className="brand-name">1st Combined Legion</p>
            <p className="subtitle">{subtitle}</p>
          </div>
        </div>

        <button
          className={`header-burger ${menuOpen ? 'open' : ''}`}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          aria-controls="main-navigation"
          onClick={() => setMenuOpen(open => !open)}
        >
          <span className="burger-box">
            <span className="burger-inner" />
          </span>
        </button>

        <nav id="main-navigation" className={`header-actions ${menuOpen ? 'open' : ''}`} aria-label="Main navigation">
          <Link to="/central-group" className="compact-nav-item" onClick={() => setMenuOpen(false)}>Member Groups</Link>
          <Link to="/info-library" className="compact-nav-item" onClick={() => setMenuOpen(false)}>1CL Wiki & Info</Link>
          <Link to="/bot-documentation" className="compact-nav-item" onClick={() => setMenuOpen(false)}>Bot Documentation</Link>
        </nav>
      </div>
    </header>
  );
}
